import tseInstance from './instance'

const getTseConfig = () => {
	return tseInstance.get('/company/tse')
}

export default getTseConfig
